import React, { useEffect, useState } from "react";
import {
  List,
  Input,
  Button,
  Form,
  message,
  Space,
  Typography,
  Card,
} from "antd";
import { PlusOutlined, DeleteOutlined, PhoneOutlined } from "@ant-design/icons";
import { Star } from "@mui/icons-material";

const { Title } = Typography;

type MobileNumber = {
  number: string;
  isPrimary: boolean;
};

type MobileManageProps = {
  primaryMobile: string;
  secondaryMobile: string[];
  setSecondaryMobile: (mobileNumbers: string[]) => void;
};

export default function MobileManage({
  primaryMobile,
  secondaryMobile,
  setSecondaryMobile,
}: MobileManageProps) {
  const [newNumber, setNewNumber] = useState<string>("");
  const [form] = Form.useForm();

  const [mobileNumbers, setMobileNumbers] = useState<MobileNumber[]>([]);

  useEffect(() => {
    setMobileNumbers([
      { number: primaryMobile, isPrimary: true },
      ...secondaryMobile.map((item) => ({ number: item, isPrimary: false })),
    ]);
  }, [primaryMobile, secondaryMobile]);

  // ฟังก์ชันเพิ่มเบอร์โทรศัพท์
  const handleAddNumber = () => {
    if (!newNumber.trim()) {
      message.warning("กรุณากรอกเบอร์โทรศัพท์");
      return;
    }

    // ตรวจสอบรูปแบบเบอร์โทรศัพท์ (10 หลัก และขึ้นต้นด้วย 0)
    const phoneRegex = /^0[0-9]{9}$/;
    if (!phoneRegex.test(newNumber)) {
      message.error(
        "รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง (ต้องเป็น 10 หลัก และขึ้นต้นด้วย 0)"
      );
      return;
    }

    // ตรวจสอบเบอร์ซ้ำ
    if (secondaryMobile.some((item) => item === newNumber)) {
      message.warning("เบอร์โทรศัพท์นี้มีอยู่แล้ว");
      return;
    }

    setSecondaryMobile([...secondaryMobile, newNumber]);
    setNewNumber("");
    form.resetFields();
    message.success("เพิ่มเบอร์โทรศัพท์สำเร็จ");
  };

  // ฟังก์ชันลบเบอร์โทรศัพท์
  const handleDeleteNumber = (id: string) => {
    setSecondaryMobile(secondaryMobile.filter((item) => item !== id));
    message.success("ลบเบอร์โทรศัพท์สำเร็จ");
  };

  // ฟังก์ชันจัดรูปแบบเบอร์โทรศัพท์
  const formatPhoneNumber = (phone: string) => {
    if (phone.length === 10) {
      //return `${phone.slice(0, 3)}-${phone.slice(3, 6)}-${phone.slice(6)}`;
      return phone;
    }
    return phone;
  };

  return (
    <Card style={{ padding: 16 }}>
      <Title level={4}>
        <PhoneOutlined style={{ marginRight: 8 }} />
        <Typography.Text
          style={{
            fontWeight: 600,
          }}
          underline>
          เบอร์โทรศัพท์ติดต่อ
        </Typography.Text>
      </Title>

      {/* รายการเบอร์โทรศัพท์ */}
      <List
        header={<div>รายการเบอร์โทรศัพท์ ({mobileNumbers.length} รายการ)</div>}
        bordered
        dataSource={mobileNumbers}
        renderItem={(item) => (
          <List.Item
            actions={[
              item.isPrimary ? (
                <Typography.Text>หมายเลขหลัก</Typography.Text>
              ) : (
                <Button
                  type="link"
                  onClick={() => handleDeleteNumber(item.number)}>
                  <DeleteOutlined />
                </Button>
              ),
            ]}
            style={{
              backgroundColor: item.isPrimary ? "#EFEFEFEF" : "white",
            }}>
            <Space
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 10,
                padding: 8,
              }}>
              <span style={{ fontSize: 16 }}>
                {formatPhoneNumber(item.number)}
              </span>
            </Space>
          </List.Item>
        )}
      />

      {/* ฟอร์มเพิ่มเบอร์ใหม่ */}
      <Form form={form} layout="inline" style={{ marginTop: 16 }}>
        <Form.Item
          name="phoneNumber"
          rules={[
            {
              pattern: /^0[0-9]{9}$/,
              message: "รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง",
            },
          ]}
          label="เพิ่มเบอร์โทรศัพท์">
          <Input
            placeholder="กรอกเบอร์โทรศัพท์ (10 หลัก)"
            value={newNumber}
            onChange={(e) => setNewNumber(e.target.value)}
            maxLength={10}
            style={{ width: 200 }}
            onPressEnter={handleAddNumber}
            size="small"
          />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleAddNumber}>
            เพิ่ม
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
}
